export default {
  methods: {
    async onSubmit() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) {
        return;
      }
      this.onFormValid();
    },
    cancel() {
      this.$emit('edit-finished-event');
    },
    onFormValid() {
    }
  },
};
